"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubqueryExprComponent = void 0;
const react_1 = __importStar(require("react"));
const expressions_1 = require("@mwater/expressions");
const ActionCancelModalComponent_1 = __importDefault(require("@mwater/react-library/lib/ActionCancelModalComponent"));
const LinkComponent_1 = __importDefault(require("./LinkComponent"));
const bootstrap_1 = require("@mwater/react-library/src/bootstrap");
const TableSelectComponent_1 = require("./TableSelectComponent");
const FilterExprComponent_1 = __importDefault(require("./FilterExprComponent"));
const ExprComponent_1 = __importDefault(require("./ExprComponent"));
const ListEditorComponent_1 = require("@mwater/react-library/src/ListEditorComponent");
const uuid_1 = __importDefault(require("uuid"));
/** Component for editing a Subquery Expression. Opens a modal for editing */
function SubqueryExprComponent(props) {
    const exprUtils = (0, react_1.useMemo)(() => new expressions_1.ExprUtils(props.schema), [props.schema]);
    const [modalOpen, setModalOpen] = (0, react_1.useState)(props.value.from == null);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(LinkComponent_1.default, { dropdownItems: [
                { id: "edit", name: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("i", { className: "fas fa-fw text-muted fa-pencil-alt" }),
                        " ",
                        T `Edit`) },
                { id: "remove", name: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("i", { className: "fas fa-fw text-muted fa-times" }),
                        " ",
                        T `Remove`) }
            ], onDropdownItemClicked: id => {
                if (id === "edit") {
                    setModalOpen(true);
                }
                else if (id === "remove") {
                    props.onChange?.(null);
                }
            } }, exprUtils.summarizeExpr(props.value)),
        props.onChange && modalOpen &&
            react_1.default.createElement(SubqueryExprModal, { ...props, value: props.value, onClose: () => setModalOpen(false) }));
}
exports.SubqueryExprComponent = SubqueryExprComponent;
/**
 * Renders a modal popup for Subquery Expression configuration.
 */
function SubqueryExprModal(props) {
    const [expr, setExpr] = (0, react_1.useState)(props.value);
    const exprUtils = (0, react_1.useMemo)(() => new expressions_1.ExprUtils(props.schema), [props.schema]);
    // Determine if the select expression is aggregate (as it doesn't need ordering)
    const isAggregate = (0, react_1.useMemo)(() => {
        return exprUtils.getExprAggrStatus(expr.select) !== "individual";
    }, [expr.select]);
    // Determine variables that can be used in the subquery and add to inner schema
    const innerSchema = (0, react_1.useMemo)(() => {
        return props.schema.addVariables(exprUtils.createSubqueryInnerVariables(expr), {});
    }, [props.schema, expr]);
    return (react_1.default.createElement(ActionCancelModalComponent_1.default, { title: T `Subquery`, onCancel: () => {
            props.onClose();
        }, onAction: () => {
            // Validate expression
            if (!expr.from) {
                alert(T `Subquery Data Source is required`);
                return;
            }
            if (!expr.select) {
                alert(T `Value to calculate is required`);
                return;
            }
            props.onChange?.(expr);
            props.onClose();
        }, size: "large" },
        react_1.default.createElement("div", { className: "alert alert-secondary", role: "alert" }, T `This interface allows you to configure a subquery expression. A subquery retrieves a value from another, unrelated table.
        To check if there are any matching rows, use "True" as the value to calculate.`),
        react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Subquery Data Source`, hint: T `Data source that will be queried in subquery` },
            react_1.default.createElement(TableSelectComponent_1.TableSelectComponent, { schema: props.schema, value: expr.from, onChange: value => setExpr({ ...expr, from: value ?? undefined }), filter: null })),
        react_1.default.createElement(bootstrap_1.FormGroup, { label: T `References to Outer Query`, help: T `These are values from the outer query that can be used in the subquery. 
          You must add any values from the outer query here to be able to use them in the subquery.
          They are then available as variables.` },
            react_1.default.createElement(OuterRefsComponent, { schema: props.schema, dataSource: props.dataSource, value: expr.outerRefs, onChange: value => setExpr({ ...expr, outerRefs: value }), table: expr.table })),
        expr.from &&
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Value to calculate` },
                react_1.default.createElement(ExprComponent_1.default, { schema: innerSchema, dataSource: props.dataSource, types: props.types, enumValues: props.enumValues, table: expr.from, value: expr.select, onChange: value => setExpr({ ...expr, select: value }), aggrStatuses: ["individual", "aggregate", "literal"] })),
        expr.from &&
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Filter Subquery Data Source` },
                react_1.default.createElement(FilterExprComponent_1.default, { schema: innerSchema, dataSource: props.dataSource, table: expr.from, value: expr.where, onChange: value => setExpr({ ...expr, where: value }) })),
        expr.from && !isAggregate && expr.select &&
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Order By`, hint: T `Sorts the results and picks the first one` },
                react_1.default.createElement(OrderByArrayEditor, { value: expr.orderBys, onChange: value => setExpr({ ...expr, orderBys: value }), table: expr.from, schema: innerSchema, dataSource: props.dataSource }))));
}
/** Edits an array of order by expressions */
class OrderByArrayEditor extends react_1.default.Component {
    render() {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(ListEditorComponent_1.ListEditorComponent, { items: this.props.value || [], onItemsChange: this.props.onChange, renderItem: (orderBy, index, onItemChange) => (react_1.default.createElement(OrderByEditor, { value: orderBy, schema: this.props.schema, dataSource: this.props.dataSource, onChange: onItemChange, table: this.props.table })), addLabel: T `+ Add Order By`, createNew: () => ({ expr: null, dir: "asc" }) })));
    }
}
class OrderByEditor extends react_1.default.Component {
    handleExprChange = (expr) => {
        this.props.onChange({ ...this.props.value, expr: expr });
    };
    handleDirToggle = () => {
        this.props.onChange({ ...this.props.value, dir: this.props.value.dir === "asc" ? "desc" : "asc" });
    };
    render() {
        return (react_1.default.createElement("div", { style: { display: "grid", gridTemplateColumns: "auto 1fr" } },
            react_1.default.createElement("a", { className: "link-plain", onClick: this.handleDirToggle }, this.props.value.dir === "asc" ? react_1.default.createElement("i", { className: "fa fa-arrow-up" }) : react_1.default.createElement("i", { className: "fa fa-arrow-down" })),
            react_1.default.createElement(ExprComponent_1.default, { schema: this.props.schema, dataSource: this.props.dataSource, types: ["text", "number", "enum", "boolean", "date", "datetime"], table: this.props.table, value: this.props.value.expr, onChange: this.handleExprChange })));
    }
}
/**
 * Component for editing inner query variables of a Subquery Expression.
 */
function OuterRefsComponent(props) {
    const { schema, dataSource, value, onChange, table } = props;
    return (react_1.default.createElement(ListEditorComponent_1.ListEditorComponent, { items: value, onItemsChange: onChange, renderItem: (item, index, onItemChange) => {
            return react_1.default.createElement(ExprComponent_1.default, { schema: schema, dataSource: dataSource, value: item.expr, onChange: expr => onItemChange({ ...item, expr }), table: table, key: item.id });
        }, createNew: () => ({ id: uuid_1.default.v4(), expr: null }), addLabel: T `Add Variable` }));
}
